export enum LocalStorageKeys {
  CreateWorkShiftLocation = 'create-work-shift-location',
  Language = 'language',
}
